
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 16c0 4.626 2.76 8.624 6.763 10.518L5.039 11.244A11.381 11.381 0 004 16zm20.101-.59c0-1.445-.533-2.445-.989-3.223-.608-.963-1.179-1.778-1.179-2.741 0-1.074.836-2.074 2.015-2.074.053 0 .104.006.155.009A12.134 12.134 0 0016 4.312c-4.192 0-7.881 2.095-10.026 5.268.282.009.547.014.772.014 1.255 0 3.198-.149 3.198-.149.647-.037.723.889.077.963 0 0-.65.074-1.373.111l4.37 12.66 2.626-7.671-1.869-4.989c-.646-.037-1.259-.111-1.259-.111-.647-.037-.571-1 .076-.963 0 0 1.981.149 3.16.149 1.255 0 3.198-.149 3.198-.149.647-.037.723.889.076.963 0 0-.651.074-1.373.111l4.337 12.563 1.197-3.895c.518-1.617.913-2.778.913-3.778zm-7.89 1.612L12.61 27.211a12.29 12.29 0 007.375-.187 1.028 1.028 0 01-.086-.161l-3.688-9.842zm10.319-6.629c.052.372.081.771.081 1.202 0 1.185-.228 2.519-.913 4.186l-3.665 10.321C25.601 24.076 28 20.312 28 16c0-2.032-.533-3.943-1.47-5.607zM16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm0 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14z"}})])
          )
        }
      }
    